/**
 * 生成uuid方法
 * @returns {string}
 */
export const createUUID = function () {
    var d = new Date().getTime();
    if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
    }
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

/**
 * 深拷贝
 * @param {*} obj 拷贝对象(object or array)
 * @param {*} cache 缓存数组
 */
export const deepClone = function (obj, cache = []) {
    // typeof [] => 'object'
    // typeof {} => 'object'
    if (obj === null || typeof obj !== 'object') {
        return obj
    }
    // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
    /**
     * 类似下面这种
     * var a = {b:1}
     * a.c = a
     * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
     */
    const hit = cache.filter(c => c.original === obj)[0]
    if (hit) {
        return hit.copy
    }

    const copy = Array.isArray(obj) ? [] : {}
    // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
    cache.push({
        original: obj,
        copy
    })
    Object.keys(obj).forEach(key => {
        copy[key] = deepClone(obj[key], cache)
    })

    return copy
}

export const filterNoDeviceOrgs = function(treeData2) {
    function loop(treeData) {
        if (treeData.isDevice === true) {
            return true;
        }

        let ret = false;
        if (treeData.children) {
            let children = [];
            treeData.children.forEach(one => {
                if (loop(one)) {
                    ret = true;
                    children.push(one);
                }
            });

            treeData.children = children;
        }

        return ret;
    }

    let retTreeData = _.cloneDeep(treeData2);
    loop(retTreeData);

    return retTreeData;

}

export const convOrgsToTree = function (orgs, devices, return_tree = false) {
    //console.log(orgs)
    

    function bindDevices(org) {
        if (org.isDevice) {
            return;
        }

        let leftDevices = [];
        devices.forEach(device => {
            if (device.platform_org_id === org.platform_org_id) {
                org.children = org.children || [];
                org.children.push(
                    {
                        isDevice: true,
                        tree_id: 'dev_' + device.device_id,
                        ...device
                    }
                );
            } else {
                leftDevices.push(device)
            }
        })

        devices = leftDevices;

        if (org.children) {
            org.children.forEach(child => {
                bindDevices(child);
            });
        }

    }

    function loop(org, orgs) {

        let children_orgs = [];
        let leftOrgs = []
        orgs.forEach(org2 => {
            if (org.platform_org_id === org2.parent_org_id) {
                //org2 = loop(org2, orgs);
                children_orgs.push({
                    isDevice: false,
                    tree_id: 'org_' + org2.platform_org_id,
                    ...org2
                });
            } else {
                leftOrgs.push(org2)
            }
        });

        orgs = leftOrgs;

        if (children_orgs.length > 0) {
            children_orgs.forEach(org3 => {
                org3 = loop(org3, orgs);
            })
        }

        if (children_orgs.length > 0) {
            org.children = children_orgs
        }

        org.isDevice = false;
        org.tree_id = 'org_' + org.platform_org_id;
        return org;
    }

    let retOrgs = [];
    orgs.find(org => {

        const findIndex = orgs.findIndex(org2 => (org2.platform_org_id === org.parent_org_id));
        if (findIndex >= 0) {//有父节点存在
            //console.log("已经存在父节点" + org.platform_org_id);
        } else {
            //console.log("开始" + org.platform_org_id);
            retOrgs.push(loop(org, orgs))
        }
    });
    //console.log("bindDevices", retOrgs);

    retOrgs = retOrgs.map(one => {
        bindDevices(one);
        return one;
    });
    console.log("after bindDevices", retOrgs);

    const unknowDevices = devices.filter(device => {
        const index = orgs.findIndex(org2 => device.platform_org_id === org2.platform_org_id);
        return index < 0
    });

    if (unknowDevices.length > 0) {
        retOrgs.push({
            tree: 'org_unknow',
            isUnknown: true,
            disabled: true,
            platform_org_id: '-1',
            platform_org_name: '未知分类',
            children: unknowDevices.map(one => {
                return {
                    disabled: true,
                    isDevice: true,
                    ...one
                }
            })
        });
    }

    console.log(retOrgs);

    // if (return_tree == false) {
    //     return retOrgs;
    // }

    if (retOrgs.length > 1) {
        console.log(retOrgs);
        let ret = retOrgs.find(one => one.platform_org_id === null);
        ret.children = (ret.children || []).concat(retOrgs.filter(one => one.platform_org_id !== null))
        return ret;
    }

    return retOrgs[0];
}

export const deepOrgIds = function deepOrgIds(one, checkedKeys = null, type = null) {
    if (type == 'device') {

        let rets = [];
        if (one.isDevice && (checkedKeys == null || checkedKeys.indexOf(one.tree_id) >= 0)) {
            rets = [
                one.device_id
            ];
        }


        for (let oneChild of one.children || []) {
            rets.push(...deepOrgIds(oneChild, checkedKeys, type));
        }

        return rets
    } else {
        let rets = [];
        if (!one.isDevice && (checkedKeys == null || checkedKeys.indexOf(one.tree_id) >= 0)) {
            rets = [
                one.platform_org_id
            ];
        }

        for (let oneChild of one.children || []) {
            rets.push(...deepOrgIds(oneChild, checkedKeys, type));
        }

        return rets
    }

}